/** Build-time public configuration. Never put secrets in VITE_* variables. */
export const config = {
  productName: import.meta.env.VITE_PRODUCT_NAME || 'SCHOOL ERP',
} as const;
